import React from 'react';

const data = [
    { category: 'Group Overview', items: ['High level Summary', 'Balance Sheet'] },
    { category: 'Aftersales', items: ['Service', 'Retail Parts', 'Trade Parts', 'MaxAssist'] },
    { category: 'MB Van', items: ['MB Van New', 'MB Van Used'] },
    { category: 'MB Truck', items: ['MB Truck New', 'MB Truck Used'] },
    { category: 'Maxus', items: ['Maxus New Van', 'Maxus New Truck', 'Maxus Used'] },
    { category: 'Indirects', items: ['Central Management', 'Marketing', 'Logistics', 'Administration', 'Rental & Geopost DPD'] }
];

const generateRandomValue = () => Math.floor(Math.random() * 100) + 1;

const counts = Object.fromEntries(
    data.flatMap((section) =>
        section.items.map((item) => [item, { Actual: generateRandomValue(), Budget: generateRandomValue(), Variance: generateRandomValue() }])
    )
);

const NominalDashboard = () => {
    return (
        <div style={styles.container}>
            <div style={styles.header}>LIVE ACCOUNTS</div>
            <div style={styles.content}>
                {data.map((section, index) => (
                    <div key={index} style={styles.section}>
                        <h4 style={styles.category}>{section.category}</h4>
                        <table style={styles.table}>
                            <thead>
                                <tr>
                                    <th style={styles.th}>Item</th>
                                    <th style={styles.th}>Actual</th>
                                    <th style={styles.th}>Budget</th>
                                    <th style={styles.th}>Variance</th>
                                </tr>
                            </thead>
                            <tbody>
                                {section.items.map((item, idx) => (
                                    <tr key={idx}>
                                        <td style={styles.td}>{item}</td>
                                        <td style={styles.td}>{counts[item].Actual}</td>
                                        <td style={styles.td}>{counts[item].Budget}</td>
                                        <td style={styles.td}>{counts[item].Variance}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ))}
            </div>
            <div style={styles.footer}>
                NB: Please note salary & expenses will not be complete until working day 7. The balances displayed will include reversing accruals and
                pre-payments identified by NL postings.
            </div>
        </div>
    );
};

const styles = {
    container: {
        width: '600px',
        margin: '20px auto',
        padding: '15px 20px',
        backgroundColor: '#31578C',
        color: 'white',
        borderRadius: '10px',
        fontFamily: 'Arial, sans-serif'
    },
    header: {
        fontWeight: 'bold',
        marginBottom: '15px',
        backgroundColor: 'white',
        color: '#31578C',
        padding: '8px',
        borderRadius: '5px',
        textAlign: 'center',
        fontSize: '16px'
    },
    content: {
        marginBottom: '10px'
    },
    section: {
        marginBottom: '20px'
    },
    category: {
        fontSize: '18px',
        marginBottom: '10px',
        textAlign: 'left',
        borderBottom: '2px solid white',
        paddingBottom: '5px'
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        backgroundColor: 'white',
        color: '#31578C',
        borderRadius: '5px',
        overflow: 'hidden'
    },
    th: {
        backgroundColor: '#27466F',
        color: 'white',
        padding: '8px',
        textAlign: 'center',
        fontSize: '14px'
    },
    td: {
        padding: '8px',
        textAlign: 'center',
        fontSize: '13px',
        borderBottom: '1px solid #ddd'
    },
    footer: {
        fontSize: '12px',
        marginTop: '15px',
        textAlign: 'center'
    }
};

export default NominalDashboard;
